export default __webpack_public_path__ + "static/media/checkno.650bea16.svg";